export default "__VITE_ASSET__786b4ac9__"